import { ISgwtMiniFooterI18N, ISgwtMiniFooterI18NLanguage } from './sgwt-mini-footer.types';

const SGWT_MINI_FOOTER_I18N_EN: ISgwtMiniFooterI18NLanguage = {
  corporateMention: 'Societe Generale',
  contactUs: 'Contact us',
  legalNotices: 'Legal notices',
  sgMarketsLink: [
    {
      type: 'important-notice',
      label: 'Important notice',
      value: 'https://www.sgmarkets.com/disclaimer/file'
    },
    {
      type: 'mandatory-legal-notice',
      label: 'SG Markets Electronic Services Terms',
      value: 'https://content.sgmarkets.com/SGM_LEGAL_NOTICE_ELEC_SERV_TERMS'
    },
    {
      type: 'website-legal-notice',
      label: 'Website legal notice',
      value: 'https://content.sgmarkets.com/SGM_LEGAL_NOTICE_WEBSITE'
    },
    {
      type: 'sg-cookies-policy',
      label: 'SG cookies policy',
      value: 'https://content.sgmarkets.com/SGM_LEGAL_NOTICE_SG_COOKIES'
    },
    {
      type: 'cookies-consent',
      label: 'Manage my cookies',
      value: ''
    },
    {
      type: 'sg-privacy-security',
      label: 'SG privacy policy & security guidelines',
      value: 'https://content.sgmarkets.com/SGM_LEGAL_NOTICE_SG_PRIVACY_SEC_GUIDELINES'
    }
  ],
  accessibility: {
    none: 'Accessibility: not compliant',
    partial: 'Accessibility: partially compliant',
    full: 'Accessibility: fully compliant'
  }
};

const SGWT_MINI_FOOTER_I18N_FR: ISgwtMiniFooterI18NLanguage = {
  corporateMention: 'Société Générale',
  contactUs: 'Nous contacter',
  legalNotices: 'Notices légales',
  sgMarketsLink: [
    {
      type: 'important-notice',
      label: 'Notice importante',
      value: 'https://www.sgmarkets.com/disclaimer/file'
    },
    {
      type: 'mandatory-legal-notice',
      label: 'Termes du Service SG Markets Electronic',
      value: 'https://content.sgmarkets.com/SGM_LEGAL_NOTICE_ELEC_SERV_TERMS'
    },
    {
      type: 'website-legal-notice',
      label: 'Mentions légales',
      value: 'https://content.sgmarkets.com/SGM_LEGAL_NOTICE_WEBSITE_FR'
    },
    {
      type: 'sg-cookies-policy',
      label: 'Politique cookies de la Société Générale',
      value: 'https://content.sgmarkets.com/SGM_LEGAL_NOTICE_SG_COOKIES_FR'
    },
    {
      type: 'cookies-consent',
      label: 'Paramétrer mes cookies',
      value: ''
    },
    {
      type: 'sg-privacy-security',
      label: 'Politique de confidentialité et recommandations de sécurité',
      value: 'https://content.sgmarkets.com/SGM_LEGAL_NOTICE_SG_PRIVACY_SEC_GUIDELINES_FR'
    }
  ],
  accessibility: {
    none: 'Accessibilité : non conforme',
    partial: 'Accessibilité : partiellement conforme',
    full: 'Accessibilité : totalement conforme'
  }
};

const SGWT_MINI_FOOTER_I18N_ES: ISgwtMiniFooterI18NLanguage = {
  corporateMention: 'Grupo Société Générale',
  contactUs: 'Contactarnos',
  legalNotices: 'Instrucciones legales',
  sgMarketsLink: [
    {
      type: 'important-notice',
      label: 'Instrucción importante',
      value: 'https://www.sgmarkets.com/disclaimer/file'
    },
    {
      type: 'mandatory-legal-notice',
      label: 'Términos del servicio SG Markets Electronic',
      value: 'https://content.sgmarkets.com/SGM_LEGAL_NOTICE_ELEC_SERV_TERMS'
    },
    {
      type: 'website-legal-notice',
      label: 'Menciones Legales',
      value: 'https://content.sgmarkets.com/SGM_LEGAL_NOTICE_WEBSITE'
    },
    {
      type: 'sg-cookies-policy',
      label: 'Política de cookies de la Société Générale',
      value: 'https://content.sgmarkets.com/SGM_LEGAL_NOTICE_SG_COOKIES'
    },
    {
      type: 'cookies-consent',
      label: 'Administrar mis cookies',
      value: ''
    },
    {
      type: 'sg-privacy-security',
      label: 'Política de confidencialidad y recomencaciones de seguridad',
      value: 'https://content.sgmarkets.com/SGM_LEGAL_NOTICE_SG_PRIVACY_SEC_GUIDELINES'
    }
  ],
  accessibility: {
    none: 'Accesibilidad: no conforme',
    partial: 'Accesibilidad: parcialmente conforme',
    full: 'Accesibilidad: totalmente conforme'
  }
};

const SGWT_MINI_FOOTER_I18N_DE: ISgwtMiniFooterI18NLanguage = {
  corporateMention: 'Groupe Société Générale',
  contactUs: 'Kontakt',
  legalNotices: 'Impressum',
  sgMarketsLink: [
    {
      type: 'important-notice',
      label: 'Wichtiger Hinweis',
      value: 'https://www.sgmarkets.com/disclaimer/file'
    },
    {
      type: 'mandatory-legal-notice',
      label: 'Bedingungen des SG Markets Electronic Service',
      value: 'https://content.sgmarkets.com/SGM_LEGAL_NOTICE_ELEC_SERV_TERMS'
    },
    {
      type: 'website-legal-notice',
      label: 'Impressum',
      value: 'https://content.sgmarkets.com/SGM_LEGAL_NOTICE_WEBSITE'
    },
    {
      type: 'sg-cookies-policy',
      label: 'Cookie-Richtlinie der Société Générale',
      value: 'https://content.sgmarkets.com/SGM_LEGAL_NOTICE_SG_COOKIES'
    },
    {
      type: 'cookies-consent',
      label: 'Meine Cookies verwalten',
      value: ''
    },
    {
      type: 'sg-privacy-security',
      label: 'Datenschutzerklärung und Empfehlungen zur Sicherheit',
      value: 'https://content.sgmarkets.com/SGM_LEGAL_NOTICE_SG_PRIVACY_SEC_GUIDELINES'
    }
  ],
  accessibility: {
    none: 'Zungänglichkeit: Konformitätsstufe A',
    partial: 'Zungänglichkeit: Konformitätsstufe AA',
    full: 'Zungänglichkeit: Konformitätsstufe AAA'
  }
};

const SGWT_MINI_FOOTER_I18N_ZH: ISgwtMiniFooterI18NLanguage = {
  corporateMention: '法国兴业集团',
  contactUs: '联系我们',
  legalNotices: '法律声明',
  sgMarketsLink: [
    {
      type: 'important-notice',
      label: '重要声明',
      value: 'https://www.sgmarkets.com/disclaimer/file'
    },
    {
      type: 'mandatory-legal-notice',
      label: 'SG Markets Electronic 服务条款',
      value: 'https://content.sgmarkets.com/SGM_LEGAL_NOTICE_ELEC_SERV_TERMS'
    },
    {
      type: 'website-legal-notice',
      label: '法律声明',
      value: 'https://content.sgmarkets.com/SGM_LEGAL_NOTICE_WEBSITE'
    },
    {
      type: 'sg-cookies-policy',
      label: '兴业集团cookies政策',
      value: 'https://content.sgmarkets.com/SGM_LEGAL_NOTICE_SG_COOKIES'
    },
    {
      type: 'cookies-consent',
      label: 'Cookies consent manager',
      value: '管理我的终端数据'
    },
    {
      type: 'sg-privacy-security',
      label: '隐私政策和安全建议',
      value: 'https://content.sgmarkets.com/SGM_LEGAL_NOTICE_SG_PRIVACY_SEC_GUIDELINES'
    }
  ],
  accessibility: {
    none: '无障碍级别： A 级',
    partial: '无障碍级别： AA 级',
    full: '无障碍级别： AAA 级'
  }
};

const SGWT_MINI_FOOTER_I18N_IT: ISgwtMiniFooterI18NLanguage = {
  corporateMention: 'Societe Generale',
  contactUs: 'Contact',
  legalNotices: 'Legal notices',
  sgMarketsLink: [
    {
      type: 'important-notice',
      label: 'Important notice',
      value: 'https://www.sgmarkets.com/disclaimer/file'
    },
    {
      type: 'mandatory-legal-notice',
      label: 'SG Markets Electronic Services Terms',
      value: 'https://content.sgmarkets.com/SGM_LEGAL_NOTICE_ELEC_SERV_TERMS'
    },
    {
      type: 'website-legal-notice',
      label: 'Website legal notice',
      value: 'https://content.sgmarkets.com/SGM_LEGAL_NOTICE_WEBSITE'
    },
    {
      type: 'sg-cookies-policy',
      label: 'SG cookies policy',
      value: 'https://content.sgmarkets.com/SGM_LEGAL_NOTICE_SG_COOKIES'
    },
    {
      type: 'cookies-consent',
      label: 'Gestione dei cookie',
      value: ''
    },
    {
      type: 'sg-privacy-security',
      label: 'SG privacy policy & security guidelines',
      value: 'https://content.sgmarkets.com/SGM_LEGAL_NOTICE_SG_PRIVACY_SEC_GUIDELINES'
    }
  ],
  accessibility: {
    none: 'Accessibilità: non conforme',
    partial: 'Accessibilità: parzialmente conforme',
    full: 'Accessibilità: conforme'
  }
};

const SGWT_MINI_FOOTER_I18N_PT: ISgwtMiniFooterI18NLanguage = {
  corporateMention: 'Société Générale',
  contactUs: 'Contacto',
  legalNotices: 'Avisos legais',
  sgMarketsLink: [
    {
      type: 'important-notice',
      label: 'Aviso importante',
      value: 'https://www.sgmarkets.com/disclaimer/file'
    },
    {
      type: 'mandatory-legal-notice',
      label: 'Condições de utilização dos serviços eletrónicos SG Markets',
      value: 'https://content.sgmarkets.com/SGM_LEGAL_NOTICE_ELEC_SERV_TERMS'
    },
    {
      type: 'website-legal-notice',
      label: 'Menções legais',
      value: 'https://content.sgmarkets.com/SGM_LEGAL_NOTICE_WEBSITE'
    },
    {
      type: 'sg-cookies-policy',
      label: 'Carta de cookies',
      value: 'https://content.sgmarkets.com/SGM_LEGAL_NOTICE_SG_COOKIES'
    },
    {
      type: 'cookies-consent',
      label: 'Configurar os meus cookies',
      value: ''
    },
    {
      type: 'sg-privacy-security',
      label: 'Política de confidencialidade e recomendações de segurança',
      value: 'https://content.sgmarkets.com/SGM_LEGAL_NOTICE_SG_PRIVACY_SEC_GUIDELINES'
    }
  ],
  accessibility: {
    none: 'Acessibilidade: não conforme',
    partial: 'Acessibilidade: parcialmente conforme',
    full: 'Acessibilidade: totalmente conforme'
  }
};

const SGWT_MINI_FOOTER_I18N_JA: ISgwtMiniFooterI18NLanguage = {
  corporateMention: 'ソシエテ・ジェネラルグループ',
  contactUs: 'お問い合わせ',
  legalNotices: '免責事項',
  sgMarketsLink: [
    {
      type: 'important-notice',
      label: '重要なお知らせ',
      value: 'https://www.sgmarkets.com/disclaimer/file'
    },
    {
      type: 'mandatory-legal-notice',
      label: 'SG Markets電子サービス規約',
      value: 'https://content.sgmarkets.com/SGM_LEGAL_NOTICE_ELEC_SERV_TERMS'
    },
    {
      type: 'website-legal-notice',
      label: '本サイトの免責事項',
      value: 'https://content.sgmarkets.com/SGM_LEGAL_NOTICE_WEBSITE'
    },
    {
      type: 'sg-cookies-policy',
      label: 'クッキーに関するポリシー',
      value: 'https://content.sgmarkets.com/SGM_LEGAL_NOTICE_SG_COOKIES'
    },
    {
      type: 'cookies-consent',
      label: 'Cookie(クッキー)の管理を行う',
      value: ''
    },
    {
      type: 'sg-privacy-security',
      label: 'プライバシーポリシーとセキュリティガイドライン',
      value: 'https://content.sgmarkets.com/SGM_LEGAL_NOTICE_SG_PRIVACY_SEC_GUIDELINES'
    }
  ],
  accessibility: {
    none: 'ウェブアクセシビリティ : JIS X 8341-3:2016に配慮',
    partial: 'ウェブアクセシビリティ : JIS X 8341-3:2016に一部準拠',
    full: 'ウェブアクセシビリティ : JIS X 8341-3:2016に準拠'
  }
};

export const SGWT_MINI_FOOTER_I18N: ISgwtMiniFooterI18N = {
  en: SGWT_MINI_FOOTER_I18N_EN,
  fr: SGWT_MINI_FOOTER_I18N_FR,
  de: SGWT_MINI_FOOTER_I18N_DE,
  es: SGWT_MINI_FOOTER_I18N_ES,
  zh: SGWT_MINI_FOOTER_I18N_ZH,
  it: SGWT_MINI_FOOTER_I18N_IT,
  pt: SGWT_MINI_FOOTER_I18N_PT,
  ja: SGWT_MINI_FOOTER_I18N_JA
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/sgwt-mini-footer/sgwt-mini-footer.i18n.ts